import Cookies from 'js-cookie'
import config from '../config'

const cookie = Cookies.withAttributes({
  path: '/',
  domain: config.cookieDomain
})

const setCookie = (key, value, options = {}) => {
  cookie.set(key, value, { expires: 7, path: '/', ...options })
}

const getCookie = (key) => {
  return cookie.get(key)
}

const removeCookie = (key) => {
  cookie.remove(key)
}

export default {
  setCookie,
  getCookie,
  removeCookie
}
